import styled from "styled-components";
import { ElementPositioningProps } from "../ComponentProps";
import Flex from "../Flex";

const ModalBody = styled(Flex).attrs<ElementPositioningProps>(props => {
  return {
    flexDirection: "column",
    px: props.px || "xxl",
    py: props.py || "xl",
    textAlign: "left",
    overflow: "auto",
  };
})``;
export default ModalBody;
